import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface CloudRunStatus {
  name: string;
  ready: boolean;
  url?: string;
  latest_revision?: string;
  image_sha?: string;
  last_deploy_at?: string;
  errore?: string;
}

export interface CloudSqlStatus {
  name?: string;
  state?: string;
  database_version?: string;
  tier?: string;
  region?: string;
  info?: string;
  errore?: string;
}

export interface SslCert {
  name: string;
  status: string;
  domains: string[];
  expire_time?: string;
}

export interface SistemaStatus {
  env: string;
  service_version: string;
  queried_at: string;
  alembic_version: string | null;
  cloud_run: CloudRunStatus[];
  cloud_sql: CloudSqlStatus;
  ssl_certs: SslCert[];
  note?: string;
}

export function useAdminSistema() {
  return useQuery({
    queryKey: ["admin-sistema"],
    queryFn: () => apiFetch<SistemaStatus>("/api/v1/admin/sistema"),
    staleTime: 20_000,
    refetchInterval: 60_000,
  });
}
